import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Play } from '../../icons';
import { log } from '../../utils/logs';
import { media } from '../../utils/styles';

export const VideoController = ({ videoUrl, cover }) => {
  const videoRef = useRef();
  const [showCover, setShowCover] = useState(true);

  useEffect(() => {
    const currentVideoRef = videoRef.current;

    const logVideoEvent = action => {
      log(action, {
        category: 'ProductPage',
        label: 'Video',
      });
    };

    const onPause = () => {
      logVideoEvent('stop');
    };
    currentVideoRef.addEventListener('pause', onPause);

    const onPlay = () => {
      logVideoEvent('play');
    };
    currentVideoRef.addEventListener('play', onPlay);

    let currentTime = 0;
    const onTimeupdate = () => {
      if (!currentVideoRef) return;
      const watched = Math.floor(currentVideoRef.currentTime);
      if (watched > currentTime) {
        currentTime = watched;
        logVideoEvent(`watchtime_${currentTime}s`);
      }
    };
    currentVideoRef.addEventListener('timeupdate', onTimeupdate);

    return () => {
      currentVideoRef.removeEventListener('pause', onPause);
      currentVideoRef.removeEventListener('play', onPlay);
      currentVideoRef.removeEventListener('timeupdate', onTimeupdate);
    };
  }, []);

  const onPlay = () => {
    setShowCover(false);
    videoRef.current.play();
  };

  return (
    <VideoWrap>
      <Video controls ref={videoRef}>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </Video>
      {showCover && (
        <>
          <Cover
            src={cover.fluid.src}
            srcSet={cover.fluid.srcSet}
            alt={cover.alt || 'video cover'}
          />
          <PlayButton aria-label="Play video" onClick={onPlay}>
            <Play />
          </PlayButton>
        </>
      )}
    </VideoWrap>
  );
};

const PlayButton = styled.button`
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  width: 125px;
  height: 125px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 5;
  &:hover {
    svg {
      fill: rgba(255, 255, 255, 0.3);
    }
  }
  ${media.phone} {
    width: 72px;
    height: 72px;
    svg {
      height: 72px;
    }
  }
`;

const VideoWrap = styled.div`
  position: relative;
`;

const Cover = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  left: 0;
  top: 0;
  z-index: 4;
`;

const Video = styled.video`
  width: 100%;
  height: auto;
`;
